// extracted by mini-css-extract-plugin
export default {"fieldWrapper":"field_wrapper_fieldWrapper__IYNPP"};